<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Progress Bar
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content content--modifier-height">
  <div class="content__row">
    <label for="status" class="content__row-label">Status</label>
    <select [(ngModel)]="selectedStatus" class="c-input-group__control" id="status">
      <ng-container *ngFor="let status of statusList">
        <option [value]="status">{{ status }}</option>
      </ng-container>
    </select>
    <label for="language" class="content__row-label">Language</label>
    <select [(ngModel)]="selectedLanguage" class="c-input-group__control" id="language">
      <ng-container *ngFor="let language of languages">
        <option [value]="language">{{ language }}</option>
      </ng-container>
    </select>
    <label for="value" class="content__row-label">Value</label>
    <select [(ngModel)]="selectedValue" class="c-input-group__control" id="value">
      <ng-container *ngFor="let value of valueList">
        <option [value]="value">{{ value }}</option>
      </ng-container>
    </select>
  </div>
  <maced-progressbar id="progressBar" [value]="selectedValue" [label]="getLabel()" [status]="selectedStatus">
  </maced-progressbar>
</div>